import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"
import { useCookies } from "react-cookie"
import { useForm } from "react-hook-form"
import classNames from "classnames"

import { loginAction } from "../../../redux/slices/authSlice"
import { login } from "../../../services/auth"
import { SignupInput, CustomButton, CustomLink } from "../../common"
import { GA_EVENTS } from "../../../constants/analytics"
import { FormattedMessage, useIntl } from "react-intl"

function LoginPage() {
  // eslint-disable-next-line no-unused-vars
  const [_, setCookie, __] = useCookies(["token"])
  const { formatMessage } = useIntl()

  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields, isValid },
    getValues,
    watch,
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      email: "",
      password: "",
    },
  })

  watch(["email", "password"])

  const values = getValues()

  const onSignIn = (data) => {
    if (loading) return;

    setLoading(true);
    login(data)
      .then((data) => {
        setLoading(false);

        setCookie("token", data.token, {
          path: "/",
          expires: new Date(Date.now() + 24 * 60 * 60 * 1000), // 1 day
        })
        dispatch(loginAction(data));

        navigate("/api-keys");
      })
      .catch((err) => {
        const error =
          err?.response?.data?.message || err?.message || "An error occurred. Please try again."
        toast.error(error)
      })
      .finally(() => setLoading(false))
  }

  return (
    <div className="login-page">
      <div className="login-page__wrapper">
        <h1 className="login-page__title ">
          <FormattedMessage id="login.greeting" />, <br />
          <span>
            <FormattedMessage id="login.welcomeBack" />
          </span>
        </h1>

        <form className="login-page__content" onSubmit={handleSubmit(onSignIn)}>
          <div className="login-page__inputs">
            <SignupInput
              register={register("email", {
                required: formatMessage({ id: "common.emailRequired" }),
              })}
              placeholder={formatMessage({ id: "common.email" })}
              error={errors.email?.message}
              touched={touchedFields.email}
              value={values.email}
              type="email"
              label={formatMessage({ id: "common.email" })}
            />
            <SignupInput
              register={register("password", {
                required: formatMessage({ id: "common.passwordRequired" }),
              })}
              placeholder={formatMessage({ id: "common.password" })}
              error={errors.password?.message}
              touched={touchedFields.password}
              value={values.password}
              type="password"
            />
            <CustomLink
              trackingEvent={GA_EVENTS.USER_SESSION.LOGIN_FORGOT}
              className={"login-page__link"}
              to={"/forgot-password"}
            >
              <FormattedMessage id="login.forgotten" />
            </CustomLink>
          </div>

          <CustomButton
            trackingEvent={GA_EVENTS.USER_SESSION.SIGN_IN}
            className={classNames("btn btn--small primary", {
              disabled: !isValid || loading,
            })}
            onClick={handleSubmit(onSignIn)}
          >
            <FormattedMessage id="login.signIn" />
          </CustomButton>
        </form>
      </div>
    </div>
  )
}

export default LoginPage
